var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"hidden-iframe",attrs:{"src":_vm.ignoreTriggerHtml}})}
var staticRenderFns = []

export { render, staticRenderFns }